export function LogoMark({ className = "h-9 w-9" }) {
    return (
        <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
            <rect x="14" y="15" width="23" height="34" stroke="#D4AF37" strokeWidth="3" />
            <rect x="27" y="15" width="23" height="34" stroke="#E4E4E7" strokeWidth="3" />
        </svg>
    );
}

export default function Logo({ className = "" }) {
    return (
        <div className={`flex items-center gap-3 ${className}`}>
            <LogoMark />
            <div className="leading-none">
                <div className="whitespace-nowrap font-serif text-xl font-semibold tracking-tight text-white lg:text-2xl">
                    DARUNA INTERIOR
                </div>
                <div className="mt-1 font-mono text-[9px] uppercase tracking-[0.3em] text-zinc-400">
                    Kaca · Aluminium
                </div>
            </div>
        </div>
    );
}
